import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Modal, Input } from '../../components/index';
import {
  tiposSegregacoesDeMassa,
} from '../../utils/listsSelect';
import {
  doPut,
  trataMensagemSucesso,
} from '../../utils/requests';

const PLACEHOLDER = 'Selecione o tipo de segregação de massa';
const LABEL = 'Segregação de massa do ';

class ModalAlteracaoSegregacaoMassa extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    tipoSegregacaoDestinatario: this.props.tipoSegregacaoDestinatario,
    tipoSegregacaoSolicitante: this.props.tipoSegregacaoSolicitante,
    touched: false,
  });

  checkIfFileCanBeSent = () => ((this.state.tipoSegregacaoDestinatario || this.state.tipoSegregacaoDestinatario === '') ||
    (this.state.tipoSegregacaoSolicitante || this.state.tipoSegregacaoSolicitante === ''));

  handleSave = () => {
    // const tipo = this.diffRequerimento();
    const url = 'alterar-tipo-segregacao-massa';
    const { protocolo } = { ...this.props };
    const { tipoSegregacaoDestinatario } = { ...this.state };
    const { tipoSegregacaoSolicitante } = { ...this.state };
    let tipo = null;
    const parametroProtocolo = protocolo;
    const objAlteracao = { protocolo: parametroProtocolo };

    if (tipoSegregacaoDestinatario && tipoSegregacaoDestinatario !== null) {
      tipo = Number(tipoSegregacaoDestinatario);
      objAlteracao.tipoSegregacaoDestinatario = tipo;
    }

    if (tipoSegregacaoSolicitante && tipoSegregacaoSolicitante !== null) {
      tipo = Number(tipoSegregacaoSolicitante);
      objAlteracao.tipoSegregacaoSolicitante = tipo;
    }

    let options;
    if (this.state.chaveConfirmacao) {
      options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
    }
    doPut(
      url,
      objAlteracao,
      this.trataSucessoResponseEnvio,
      this.trataErrosResponse,
      options,
    );
  }

  trataSucessoResponseEnvio = () => {
    this.handleClose();
    this.props.atualizarTipoSegregacaoMassaDestinatario(this.state.tipoSegregacaoDestinatario);
    this.props.atualizarTipoSegregacaoMassaSolicitante(this.state.tipoSegregacaoSolicitante);
    trataMensagemSucesso(['Tipo de segregação de massa alterada']);
  }

  modalContent = () => (
    <React.Fragment>
      <div className="row">
        {this.props.origem === 'destinatario' ?
          <Grid cols="8 8 12 12">
            <Input
              placeholder={PLACEHOLDER}
              label={LABEL}
              itemList={tiposSegregacoesDeMassa}
              onChange={e => this.handleChange(e, 'tipoSegregacaoDestinatario')}
              value={this.state.tipoSegregacaoDestinatario}
              touched={this.state.touched}
              custom
            />
          </Grid>
        :
          <Grid cols="8 8 12 12">
            <Input
              placeholder={PLACEHOLDER}
              label={LABEL}
              itemList={tiposSegregacoesDeMassa}
              onChange={e => this.handleChange(e, 'tipoSegregacaoSolicitante')}
              value={this.state.tipoSegregacaoSolicitante}
              touched={this.state.touched}
              custom
            />
          </Grid>
        }
      </div>
    </React.Fragment>
  )

  modalFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          disabled={!this.checkIfFileCanBeSent()}
          hint="Salvar"
          onClick={this.handleSave}
          title="Salvar"
        />
      </div>
    </React.Fragment>
  )

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleClose = () => {
    this.setState({ tipoSegregacaoDestinatario: null }, this.props.handleModal('exibirModalSegregacaoMassa'));
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="md"
        showModal={this.props.showModal}
        title="Alterar o tipo de segregação de massa"
      />
    );
  }
}

ModalAlteracaoSegregacaoMassa.propTypes = {
  tipoRequerimento: PropTypes.number.isRequired,
  protocolo: PropTypes.string.isRequired,
  tipoSegregacaoDestinatario: PropTypes.string.isRequired,
  tipoSegregacaoSolicitante: PropTypes.string.isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  atualizarTipoSegregacaoMassaDestinatario: PropTypes.func,
  atualizarTipoSegregacaoMassaSolicitante: PropTypes.func,
}.isRequired;

export default ModalAlteracaoSegregacaoMassa;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalAlteracaoSegregacaoMassa.jsx